
<template>
    <svg fill="#000000" width="130px" height="130px" viewBox="0 0 24 24" id="check-lists-square-2" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" class="icon flat-color">
        <g id="SVGRepo_bgCarrier" stroke-width="0"/>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
        <g id="SVGRepo_iconCarrier">           
        <rect id="primary" x="2" y="2" width="20" height="20" rx="2" style="fill: #ffffff;"/>           
        <path id="secondary" d="M16,11a1,1,0,0,1-.71-.29l-1-1a1,1,0,0,1,1.42-1.42l.29.3,1.29-1.3a1,1,0,1,1,1.42,1.42l-2,2A1,1,0,0,1,16,11Zm.71,5.71,2-2a1,1,0,0,0-1.42-1.42L16,14.59l-.29-.3a1,1,0,0,0-1.42,1.42l1,1a1,1,0,0,0,1.42,0ZM6,16h5a1,1,0,0,0,0-2H6a1,1,0,0,0,0,2Zm0-6h5a1,1,0,0,0,0-2H6a1,1,0,0,0,0,2Z" style="fill: #12760A;"/>           
        </g>          
    </svg>
</template>
